export default {
    websiteTitle: 'N.R.P.L. —  New Review of the Peripatetic Lyceum',
    copyrightOwner: "DMG",
    description: 'Omnis mundi creatura / quasi liber et pictura / nobis est in speculum <br> <i>every creature of the world is to us like a book, and a picture, and a mirror</i>',
    apiBaseUrl: 'https://nrpl.xyz/api',    
    librarianEmail: 'garden@disroot.org',
    year: '2025',
};
